import Application from "../../Application";
import CaseLawDocumentCreationPresenter, {
  ICaseLawDocumentCreationPresenter
} from "../presenter/CaseLawDocumentCreationPresenter";
import GetAllOrganisationsInteractor from "../../organisations/interactors/GetAllOrganisationsInteractor";
import GetAllCourtCaseConnectionTypesInteractor from "./GetAllCourtCaseConnectionTypesInteractor";
import { GenericCodebookTypes } from "../../core/common/Constants";
import GetGenericCodebookInteractor from "../../codebooks/interactor/GetGenericCodebookInteractor";

export default class ShowCaseLawDocumentCreationInteractor {
  private application: Application;
  private output?: ICaseLawDocumentCreationPresenter;
  private getAllOrganisationsInteractor: GetAllOrganisationsInteractor;
  private getGenericCodebookInteractor: GetGenericCodebookInteractor;
  private getAllCourtCaseConnectionTypesInteractor: GetAllCourtCaseConnectionTypesInteractor;

  constructor({
    application,
    getAllOrganisations,
    getAllCourtCaseConnectionTypes,
    getGenericCodebook
  }) {
    this.application = application;
    this.getAllOrganisationsInteractor = getAllOrganisations;
    this.getGenericCodebookInteractor = getGenericCodebook;
    this.getAllCourtCaseConnectionTypesInteractor =
      getAllCourtCaseConnectionTypes;
    this.getGenericCodebookInteractor = getGenericCodebook;
  }
  private async getAllOrganisations() {
    return this.getAllOrganisationsInteractor.execute();
  }
  private async getAllCourtCaseConnectionTypes() {
    return this.getAllCourtCaseConnectionTypesInteractor.execute();
  }
  private async getCourtCaseTypes() {
    return this.getGenericCodebookInteractor.execute(
      GenericCodebookTypes.COURT_CASE_TYPE,
      false
    );
  }

  private async getDecisionTypes() {
    return this.getGenericCodebookInteractor.execute(
      GenericCodebookTypes.DECISION_TYPE,
      false
    );
  }
  private async getReferenceLists() {
    return Promise.all([
      this.getAllOrganisations(),
      this.getAllCourtCaseConnectionTypes(),
      this.getCourtCaseTypes(),
      this.getDecisionTypes()
    ]);
  }

  execute() {
    this.output = CaseLawDocumentCreationPresenter({
      application: this.application,
      initialState: {
        previousSelectedIds: [],
        organisations: [],
        selectedOrganisationId: NaN,
        caseLawDocumentTypes: [],
        connectedCourtCasesList: [],
        organisationIndexes: [],
        selectedCourtCases: [],
        selectedIndex: {},
        parentGroupList: [],
        secondGroupList: [],
        selectedParentGroupId: [],
        selectedSecondGroupId: [],
        publishedCaseLawDocuments: [],
        courtCaseSelectionResult: undefined,
        invalidatePublishedCaseLawDocsVisible: false,
        courtCaseConnectionTypeList: [],
        createCourtCasePopupVisible: false,
        createCourtCaseModalVisible: false,
        courtCaseTypes: [],
        decisionTypes: [],
        indexDataModalVisible: false
      }
    });
    this.getReferenceLists().then(
      ([
        organisations,
        courtCaseConnectionTypeList,
        courtCaseTypes,
        decisionTypes
      ]) =>
        this.output?.loadReferenceValues(
          organisations,
          courtCaseConnectionTypeList,
          courtCaseTypes,
          decisionTypes
        )
    );
    return this.output;
  }
}
